import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'src/makeStyles';
import { useTranslation } from 'react-i18next';
import ButtonV1 from 'components/Button/ButtonV1';
import ActionStatusModal from '../../ActionStatusModal';
import H3 from '../../H3';
import { TP } from '../../../constants/consts';
import TextButton from '../../TextButton';
import { colors } from '../../../constants/styleConstants';

const useStyles = makeStyles()({
  title: {
    fontSize: 20,
    fontFamily: 'RobotoBold',
  },
});

const ConfirmDeleteModal = ({
  className,
  closeModal,
  onDelete,
  title,
  text,
  description,
  actionButtonLabel,
  loading,
  buttonVariant,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <ActionStatusModal
      isOpened
      className={className}
      onClose={closeModal}
      type="warning"
      title={<H3 className={classes.title}>{title}</H3>}
      buttons={[
        <TextButton
          onClick={closeModal}
          style={{ color: colors.text, fontWeight: 'bold', padding: '0.73rem' }}
          key="approve-button"
        >
          {t(`${TP}.m_CANCEL`)}
        </TextButton>,
        <ButtonV1 variant={buttonVariant} onClick={onDelete} key="cancel-button" isLoading={loading}>
          {t(actionButtonLabel)}
        </ButtonV1>,
      ]}
      description={description}
    >
      {text}
    </ActionStatusModal>
  );
};

ConfirmDeleteModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  title: PropTypes.string,
  text: PropTypes.string,
  actionButtonLabel: PropTypes.string,
  loading: PropTypes.bool,
  buttonVariant: PropTypes.string,
  className: PropTypes.string,
};

ConfirmDeleteModal.defaultProps = {
  title: '',
  text: '',
  actionButtonLabel: `${TP}.m_DELETE`,
  loading: false,
};

export default ConfirmDeleteModal;
